export enum MspInProductTrialsOverlayWindowEventType {
  Default = 'defaultOverlayWindowEvent',
  LearnMoreMenuOverlay = 'learnMoreMenuOverlayWindowEvent',
  DismissMenuOverlay = 'dismissMenuOverlayWindowEvent',
  HowTo = 'howToOverlayWindowEvent',
  LearnMoreCompaniesOverlay = 'learnMoreCompaniesOverlayWindowEvent',
  DismissCompaniesOverlay = 'dismissCompaniesOverlayWindowEvent',
}

export class OnMspInProductTrialsOverlayWindowButtonClick extends CustomEvent<{
  eventType: MspInProductTrialsOverlayWindowEventType;
}> {
  constructor(eventType: MspInProductTrialsOverlayWindowEventType) {
    super(MspInProductTrialsOverlayWindowEventType.Default, {
      detail: {
        eventType: eventType,
      },
      bubbles: true,
      composed: true,
    });
  }
}
